export const caseVersion = '0.30.0'; // x-release-please-version
